module.exports = __webpack_public_path__ + "img/A67362_36150C_5E2E1E_F6C3BF-256px.52e7dcbe.png";